import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=655f53ce&scoped=true"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomHeader.vue?vue&type=style&index=0&id=655f53ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f53ce",
  null
  
)

export default component.exports